import VpIcon from './src/icon'
export default VpIcon


// WEBPACK FOOTER //
// ./src/components/icon/index.js